import { Badge } from '@radix-ui/themes';
import { RadixColor } from 'enums/radix';
import { TransactionType } from 'lib/enums/transaction';
import { useMemo } from 'react';

export const BadgeTrxType = (props: { value: TransactionType }) => {
  const color = useMemo<RadixColor>(() => {
    switch (props.value) {
      case TransactionType.Buy: {
        return 'green';
      }
      case TransactionType.Sell: {
        return 'red';
      }
      case TransactionType.Drip: {
        return 'blue';
      }
      case TransactionType.Bonus: {
        return 'yellow';
      }
      default: {
        return 'gray';
      }
    }
  }, [props.value]);

  return <Badge color={color}>{props.value.toUpperCase()}</Badge>;
};
